module.exports = __webpack_public_path__ + "static/media/chevron_down_selected.719cb93a.svg";